export const InvoiceNotesAction = {
    AddInvIDForNotes: "ADDINVIDFORNOTES",
    RemInvIDForNotes:"REMINVIDFORNOTES"
}

const InitInvIDforNotes = [];

export const InvoiceNotesReducer = (invIdforNote = InitInvIDforNotes, actions) => {
    switch (actions.type) {

        case InvoiceNotesAction.AddInvIDForNotes:
            invIdforNote.push(actions.payload);
            return invIdforNote;
        case InvoiceNotesAction.RemInvIDForNotes:
            invIdforNote = [];
            return invIdforNote;
        default:
            return invIdforNote;
    }
}